import React from "react";
import { I18n } from "@bookingcom/lingojs-core";
import { I18nProvider } from "@bookingcom/lingojs-react";
import { CopyExperimentContext } from "@bookingcom/lingojs-experiments";
import { getMessagesFunctionRuntime } from "@bookingcom/lingojs-compiler";
import { trackWithDefaultStage } from "@flights/et-universal";
import useGlobalContext from "../../hooks/useGlobalContext.js";
import useUserAgent from "../../hooks/useUserAgent.js";
import { getCopyExperimentParamsClient } from "../../utils/onTranslateUtils.js";
export default function I18nProviderRenderer(props) {
    const { showCopyTags: showTags, env, ipCountry } = useGlobalContext();
    const { isMobile } = useUserAgent();
    const { i18nState } = props;
    if (!i18nState)
        throw new Error("localeID not present on window");
    const { locale, plural, clientState, dictionary, messages } = i18nState;
    const expMessages = getMessagesFunctionRuntime(dictionary);
    const copyExperimentParams = getCopyExperimentParamsClient(ipCountry, isMobile);
    const context = CopyExperimentContext.fromClientSidePayloadJSON(clientState);
    const i18n = new I18n(locale, messages, plural);
    i18n.addMessages(expMessages);
    i18n.onTranslate((tag, variables) => {
        const data = context.getVariants(locale, tag, variables, copyExperimentParams);
        if (!data || !data.matchFound)
            return tag;
        if (!data.experimentTagName)
            return tag;
        const variant = trackWithDefaultStage(data.experimentTagName, 1);
        const copyVariant = data.variants?.[variant - 1];
        if (copyVariant?.item && variables)
            variables["item"] = copyVariant.item;
        return copyVariant?.tag || tag;
    });
    i18n.setShowTags(!!showTags);
    if (env === "prod")
        i18n.setFallbackRenderer(() => "");
    return React.createElement(I18nProvider, { store: i18n }, props.children);
}
